import { PageFrame } from '../../components/PageFrame';
import { SafeExitLink } from './SafeExitLink';

// S-SCR-006 End-Early State: same minimalism as PausedState — a pure
// state-transition screen. Whatever ended the session (learner-initiated
// "I want to stop," or any other terminal-non-completed sessionStatus
// PracticeTask's Task 1 routing hands off here) has already happened by
// the time this screen renders, so there is nothing to record on mount
// and no reason to call getCurrentPractice() — no item content or prompt
// is fetched or rendered here at all. This screen takes no props about
// *how* the session ended; it only knows that it did.
//
// Copy is deliberately neutral and blame-free per the controlling prompt
// (§10.6: "neutral outcome and teacher-determined next step; no blame or
// diagnosis") and offers no re-entry/restart affordance — this pack does
// not build re-entry into an ended session; a new entry code from the
// teacher (existing, separate T-SCR-006 functionality) is how a learner
// would start anything new.
export function EndEarlyState() {
  return (
    <PageFrame title="Your activity has ended" audience="learner">
      {/* A calm, neutral marker -- not a tick (nothing was "achieved")
          and not a warning (nothing went wrong), per §10.6. */}
      <div className="mt-6 grid justify-items-center gap-4 text-center">
        <span
          aria-hidden="true"
          className="grid size-20 place-items-center rounded-full bg-paper-2 ring-8 ring-paper-2/60"
        >
          <svg
            viewBox="0 0 24 24"
            className="size-10 text-muted"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <path d="M7 12h10" />
          </svg>
        </span>
        <p className="max-w-md text-lg leading-relaxed text-ink-soft">
          Your activity has ended. Your teacher or grown-up will help you with
          what's next.
        </p>
      </div>

      <SafeExitLink />
    </PageFrame>
  );
}
